// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"59":"f90ccc70","286":"f90ccc70","531":"16abac91"}[chunkId] + ".chunk.css";
};